import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { SharedLoaderSpinner } from "@components/loader/shared";

export default observer(function ChatReplyScrollingLoader() {
	const rootStore = useRootAppStore();

	if (!rootStore.chatViewStore.replyScrollingLoader) {
		return null;
	}

	return (
		<div className="chat__loader loader__spinner">
			<SharedLoaderSpinner />
		</div>
	);
});
